/* eslint-disable eqeqeq */
import { OrderUI } from '@next-order/next-order-components';
import OrderPreView from 'components/OrderPreView';
import { toggleMobileCart } from 'containers/Home/actions';
import { selectStoreConfig } from 'containers/Layout/selectors';
import {
  LOGIN_FROM_TYPE,
  MENU_ORDER_TYPE,
  ORDER_STAGE_TYPES,
} from 'helpers/enums';
import { ArrowRightIcon, LoadingIcon } from 'nexticons/outline';
import { useDispatch, useSelector } from 'react-redux';
import OrderCartPreFooter from './OrderCartPreFooter';
import { isMobile } from 'helpers/isMobile';
import classNames from 'classnames';
import { useEffect } from 'react';
import moment from 'moment';
import { getEffectivePreparationTimes } from 'helpers/orderValueTimeAdjust';
import { useAuth } from 'contexts/AuthProvider';

export default function Cart({
  incrementItemQuantity,
  decrementItemQuantity,
  incrementExtraQuantity,
  decrementExtraQuantity,
  updateOrderDeliveryAddress,

  updateDeliveryPickupTime,
  cartState,
  setCartState,
  requestSlotsRefresh,
  toggleErrorStateForFutureTimeSelection,
  toggleErrorStateForTableSelection,
  dineInObjects,
  floors,
  addTableToOrder,
  switchSections,
  updateOrderStageHandler,
  onClickItemHandler,
  getStoreStatus,
  getMinOrderPrice,
  isSoldOutPresent,
  isOutOfSchedulePresent,
  isOtherThanSelectedOrderTypePresent,
  removeItemFromOrder,
  deliveryAddressMissing,
  updateVoucher,
  getDiscountedAmount,
  removeVoucher,
  voucherBtnRef,
}) {
  const { userDetails, orderSetup, currentOrder, isMinifiedVersion } =
    useSelector((state) => state.homeReducer);
  const order = useSelector((state) => state.orderReducer);
  const storeConfig = useSelector(selectStoreConfig);
  const { setState: setAuthState } = useAuth();

  const dispatch = useDispatch();

  const goToNextStage = () => {
    // Check if user is not logged in
    if (userDetails == null) {
      setAuthState({ loginFrom: LOGIN_FROM_TYPE.MAIN });
      updateOrderStageHandler(ORDER_STAGE_TYPES.OAUTH_FORM);
    } else {
      updateOrderStageHandler(ORDER_STAGE_TYPES.REVIEW);
    }
  };

  const isOrderSetupLoading =
    !orderSetup || Object.keys(orderSetup).length === 0;
  const isDineIn =
    orderSetup?.isDineInOn && window.location.pathname.includes('/dine-in');

  const isDisabled =
    isSoldOutPresent ||
    isOutOfSchedulePresent ||
    isOtherThanSelectedOrderTypePresent ||
    !currentOrder?.isAllowToConfirm ||
    !getStoreStatus()?.isDisplay;

  useEffect(() => {
    const availableTimes =
      currentOrder.orderType === MENU_ORDER_TYPE.delivery
        ? cartState?.deliveryTimes
        : cartState?.pickUpTimes;
    if (
      currentOrder &&
      currentOrder.deliveryDate &&
      availableTimes?.length > 0 &&
      availableTimes[0].times &&
      availableTimes[0].times.length > 0
    ) {
      let today = moment(
        moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
        'YYYY-MM-DD HH:mm'
      );
      const effectivePrep = getEffectivePreparationTimes(
        orderSetup,
        currentOrder?.payableAmount
      );
      today = today.add(
        currentOrder.orderType === MENU_ORDER_TYPE.pickup
          ? effectivePrep.pickUpTime
          : effectivePrep.deliveryTime,
        'minutes'
      );

      let delDate = moment(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm');

      // Only update if current delivery date is in the past
      if (today.isAfter(delDate)) {
        const timeObj = availableTimes[0].times[0];
        const deliveryDate = moment(
          `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
          'YYYY-MM-DD HH:mm A'
        );

        if (deliveryDate.isBefore(today)) {
          updateDeliveryPickupTime(
            deliveryDate,
            timeObj.shiftId,
            false,
            0,
            true
          );
        }
      }
    } else if (currentOrder.orderType === MENU_ORDER_TYPE.dinein) {
      if (!currentOrder.deliveryDate) {
        const deliveryDate = moment();

        updateDeliveryPickupTime(deliveryDate, false, false, 0, false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    orderSetup?.pickUpTime,
    orderSetup?.deliveryTime,
    orderSetup?.isOrderValueTimeAdjustEnabled,
    orderSetup?.orderTimeRules,
    currentOrder?.payableAmount,
    storeConfig?.timeZone,
    currentOrder?.orderType,
    cartState?.deliveryTimes,
    cartState?.pickUpTimes,
  ]);

  return (
    <>
      <OrderUI
        hideScrollbar={navigator.userAgent.indexOf('Win') !== -1}
        actionGroup={
          <OrderUI.SwitchList
            activeID={currentOrder.orderType}
            setActiveID={(e, id) => switchSections(e, id)}
            switchList={
              !isOrderSetupLoading
                ? currentOrder.orderType !== MENU_ORDER_TYPE.dinein && !isDineIn
                  ? [
                      ...(orderSetup?.isPickupOn
                        ? [{ id: MENU_ORDER_TYPE.pickup, title: 'Pickup' }]
                        : []),
                      ...(orderSetup?.isDeliveryOn
                        ? [{ id: MENU_ORDER_TYPE.delivery, title: 'Delivery' }]
                        : []),
                    ]
                  : [
                      ...(orderSetup?.isDineInOn
                        ? [{ id: MENU_ORDER_TYPE.dinein, title: 'Dine In' }]
                        : []),
                    ]
                : []
            }
          />
        }
        footer={
          <>
            <OrderUI.FooterButton
              rightIcon={
                isMinifiedVersion ? (
                  <LoadingIcon strokeWidth={3} width={16} />
                ) : (
                  <ArrowRightIcon strokeWidth={3} width={16} />
                )
              }
              onClick={goToNextStage}
              extendedClassName={classNames({ 'opacity-75': isDisabled })}
              disabled={isMinifiedVersion}
            >
              {getStoreStatus()?.text || ''}
              {getStoreStatus()?.isDisplay && (
                <span className='visible-xs visible-sm'>
                  {getMinOrderPrice() == 0
                    ? ` ${storeConfig.currency}${currentOrder.payableAmount}`
                    : ''}
                </span>
              )}
            </OrderUI.FooterButton>
          </>
        }
        ocCloseOrderBar={() => dispatch(toggleMobileCart(false))}
        preFooter={
          <OrderCartPreFooter onClickItemHandler={onClickItemHandler} />
        }
        title={isMobile() ? '' : 'Order'}
      >
        {currentOrder.stage <= ORDER_STAGE_TYPES.PAYMENT &&
          currentOrder.orderType &&
          orderSetup &&
          ((currentOrder.orderType !== MENU_ORDER_TYPE.dinein &&
            (orderSetup.isPickupOn || orderSetup.isDeliveryOn)) ||
            (currentOrder.orderType === MENU_ORDER_TYPE.dinein &&
              orderSetup?.isDineInOn)) && (
            <OrderPreView
              ref={voucherBtnRef}
              incrementItemQuantity={incrementItemQuantity}
              decrementItemQuantity={decrementItemQuantity}
              incrementExtraQuantity={incrementExtraQuantity}
              decrementExtraQuantity={decrementExtraQuantity}
              updateOrderDeliveryAddress={updateOrderDeliveryAddress}
              allSuburbs={order.allSuburbs}
              cartState={cartState}
              setCartState={setCartState}
              requestSlotsRefresh={requestSlotsRefresh}
              updateDeliveryPickupTime={updateDeliveryPickupTime}
              toggleErrorStateForFutureTimeSelection={
                toggleErrorStateForFutureTimeSelection
              }
              toggleErrorStateForTableSelection={
                toggleErrorStateForTableSelection
              }
              dineInObjects={dineInObjects}
              floors={floors}
              addTableToOrder={addTableToOrder}
              isDineIn={isDineIn}
              removeItemFromOrder={removeItemFromOrder}
              onClickItemHandler={onClickItemHandler}
              deliveryAddressMissing={deliveryAddressMissing}
              updateVoucher={updateVoucher}
              getDiscountedAmount={getDiscountedAmount}
              removeVoucher={removeVoucher}
            />
          )}
      </OrderUI>
    </>
  );
}
